import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import DateFilter from '../../../../Filters/DateSelectorFilter';

const TripDayFilter = ({
  value, onChange, inputProps = {}, ablePast, minDate, maxDate,
}) => {
  const handleTripDayChange = (selectedDate) => {
    onChange(selectedDate ? dayjs(selectedDate).format('YYYY-MM-DD') : undefined);
  };

  return (
    <div className="relative max-w-full">
      <DateFilter
        onChange={(date) => handleTripDayChange(date)}
        label={inputProps.placeholder}
        value={value}
        variant="outline"
        widthInside="max-w"
        filterButtonMaxWidth="max-w"
        minDate={minDate}
        maxDate={maxDate}
        ablePast={ablePast}
      />
    </div>
  );
};

TripDayFilter.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  inputProps: PropTypes.objectOf(PropTypes.string).isRequired,
  ablePast: PropTypes.bool,
  minDate: PropTypes.string.isRequired,
  maxDate: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
};

TripDayFilter.defaultProps = {
  ablePast: undefined,
};

export default TripDayFilter;
